import { useState } from "react";
import { Play, Smartphone, Loader2, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const API = process.env.REACT_APP_BACKEND_URL;
const dur = (s) => (s ? `${Math.floor(s / 60)}:${String(Math.round(s % 60)).padStart(2, "0")}` : "");

/** How-to video card inside an Ask Kingly answer: tap to play inline, or text yourself the link. */
export default function AskVideoCard({ v }) {
  const [playing, setPlaying] = useState(false);
  const [texting, setTexting] = useState(false);
  const textMe = async () => {
    setTexting(true);
    try { const { data } = await api.post("/help/videos/text-me", { slug: v.slug }); toast.success(`Texted the link to your mobile ending ${data.to}`); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setTexting(false); }
  };
  return (
    <div className="rounded-xl border border-amber-200 bg-white overflow-hidden" data-testid={`ask-video-${v.slug}`} data-no-translate="">
      {playing ? (
        <video src={`${API}${v.url}`} poster={v.poster_url ? `${API}${v.poster_url}` : undefined} controls autoPlay playsInline className="w-full aspect-video bg-black" data-testid={`ask-video-player-${v.slug}`} />
      ) : (
        <button type="button" onClick={() => setPlaying(true)} className="relative w-full aspect-video bg-zinc-900 flex items-center justify-center group" data-testid={`ask-video-play-${v.slug}`}>
          {v.poster_url && <img src={`${API}${v.poster_url}`} alt="" className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" />}
          <span className="relative w-12 h-12 rounded-full bg-amber-400 text-slate-900 flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform"><Play className="w-5 h-5 ml-0.5" /></span>
          {v.duration && <span className="absolute bottom-2 right-2 text-[11px] font-semibold bg-black/70 text-white rounded px-1.5 py-0.5">{dur(v.duration)}</span>}
        </button>
      )}
      <div className="px-3 py-2 flex items-center gap-2">
        <div className="flex-1 min-w-0">
          <div className="text-xs font-semibold text-slate-800 truncate">{v.num}. {v.title}</div>
          <div className="text-[11px] text-slate-500">{v.area} · how-to video</div>
        </div>
        <button type="button" onClick={textMe} disabled={texting} className="shrink-0 inline-flex items-center gap-1 text-[11px] font-semibold text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-2 py-1 hover:bg-amber-100 disabled:opacity-60" data-testid={`ask-video-textme-${v.slug}`}>
          {texting ? <Loader2 className="w-3 h-3 animate-spin" /> : <Smartphone className="w-3 h-3" />} Text me
        </button>
        <a href={v.watch_url} target="_blank" rel="noopener noreferrer" className="shrink-0 text-slate-400 hover:text-amber-700" title="Open full page" data-testid={`ask-video-open-${v.slug}`}><ExternalLink className="w-3.5 h-3.5" /></a>
      </div>
    </div>
  );
}
